module.exports = __webpack_public_path__ + "img/search3_w.e2c9eb08.svg";